import React from 'react'
import { Button, TableCardHeader } from 'react-md'

const SaleListActions = ({ title, onRefreshClick }) => (
  <TableCardHeader title={title} visible={false}>
    <Button icon onClick={onRefreshClick}>refresh</Button>
  </TableCardHeader>
)

export default SaleListActions



// WEBPACK FOOTER //
// ./src/containers/Sales/SaleListActions.js